import { StateType } from '../../index';

export const announcementsDataSelector = (state: StateType) => state.getIn(['dashboard', 'announcements', 'data']);
export const announcementsIsFetchingSelector = (state: StateType) => state.getIn(['dashboard', 'announcements', 'isFetching']);
